module.exports = __webpack_public_path__ + "static/media/27459551_1966554360274993_8858553953305320977_n.5bb21b11.jpg";